/**
 * Adapted from https://github.com/DavidWells/analytics/blob/master/packages/analytics-util-queue/src/index.js
 * but modified to add comments and TypeScript types.
 */ /**
 * Handler function type that processes a batch of items from the queue.
 * @typeParam T - The type of items in the queue.
 * @param removed - The items removed from the queue.
 * @param queue - The remaining items in the queue.
 */ /**
 * Default no-operation function.
 */ const noOp = ()=>{};
/**
 * Creates a smart queue for managing and processing items.
 * @typeParam T - The type of items in the queue.
 * @param handler - Function to process the queue items.
 * @param opts - Configuration options for the queue.
 * @returns An object with methods to control the queue.
 */ function smartQueue(handler, opts = {}) {
    let timer;
    let tmp;
    let running;
    const queue = opts.initial || [];
    const max = opts.max || Infinity;
    const int = opts.interval || 10e3;
    const onEmpty = opts.onEmpty || noOp;
    const onPause = opts.onPause || noOp;
    /**
   * Processes a batch of items from the queue.
   * @param all - If true, processes all items immediately.
   */ function batch(all) {
        clearInterval(timer);
        const removed = queue.splice(0, max);
        if (removed.length) {
            handler(removed, queue);
        }
        if (!queue.length) {
            running = false;
            return onEmpty(queue);
        }
        if (all) {
            return batch();
        }
        return ticker();
    }
    /**
   * Starts the interval for processing the queue.
   */ function ticker() {
        running = true;
        timer = setInterval(batch, int);
    }
    if (queue.length) {
        ticker();
    }
    return {
        /**
     * Flushes the queue, optionally processing all items.
     * @param all - If true, processes all items immediately.
     */ flush: (all)=>{
            batch(all);
        },
        /**
     * Resumes processing the queue.
     */ resume: ()=>{
            batch();
        },
        /**
     * Adds an item to the queue.
     * @param val - The item to add to the queue.
     * @returns The new length of the queue.
     */ push: (val)=>{
            tmp = queue.push(val);
            if (tmp >= max && !opts.throttle) {
                batch();
            }
            if (!running) {
                ticker();
            }
            return tmp;
        },
        /**
     * Gets the current size of the queue.
     * @returns The length of the queue.
     */ size: ()=>{
            return queue.length;
        },
        /**
     * Pauses processing the queue, optionally flushing remaining items.
     * @param toFlush - If true, processes remaining items before pausing.
     */ pause: (toFlush)=>{
            if (toFlush) batch();
            clearInterval(timer);
            running = false;
            onPause(queue);
        }
    };
}

export { smartQueue };
//# sourceMappingURL=queue.js.map
